import CreateDeliveryDealTable from "@components/Delivery/CreateDeliveryDeal/Table";
import { ConfirmProvider } from "material-ui-confirm";
import { useParams } from "react-router-dom";
import { getOffersByDeliveryQueryVariables } from "@/features/offers/cache";
import { useFindAllOffersQuery, useFindDeliveryByIdQuery } from "@/libs/generated/hooks";
import type { OfferObject } from "@/libs/generated/types";

import { OffersTable } from "../components/Offer/Table/offers-table";

function OffersTableRoute() {
  const { id } = useParams();
  const hasDeliveryId = id != null;
  const deliveryId = hasDeliveryId ? Number(id) : 0;
  const { data: dataOffers, isPending: loadingOffers } = useFindAllOffersQuery(
    getOffersByDeliveryQueryVariables(deliveryId),
    { enabled: hasDeliveryId }
  );

  const offersData = dataOffers?.findAllOffers?.records ?? [];
  const {
    data: graphQlData,
    isPending: isLoading,
    error,
  } = useFindDeliveryByIdQuery({ GetByIdInput: { id: deliveryId } }, { enabled: hasDeliveryId });
  const data = graphQlData?.findDeliveryById;
  const isError = Boolean(error);

  if (!hasDeliveryId) {
    return <>La livraison est introuvable.</>;
  }

  if (isLoading || !data) {
    return <span>Loading...</span>;
  }
  if (isError) {
    return (
      <span>
        Error:
        {String(error)}
      </span>
    );
  }
  return (
    <>
      <CreateDeliveryDealTable
        id={String(data.id)}
        date={data.carPickUpDate}
        representative={data.representativeCompany ?? data.clientFirstName ?? ""}
        login={data.fromAddress?.city ?? "—"}
        logout={data.toAddress?.city ?? "—"}
        numberOfVehicles={data.numberOfVehicles}
      />
      <ConfirmProvider>
        <OffersTable
          data={offersData as OfferObject[]}
          isLoading={loadingOffers}
          emptyMessage="Aucune offre n'a été soumise."
        />
      </ConfirmProvider>
    </>
  );
}

export default OffersTableRoute;
